/** Muted classroom-pack choices are metadata-only until the kid auditions them. */
export const isAudioEligible = (track) => !(track?.classSlot && track.muted);

export const audioEligibleTracks = (tracks = []) => tracks.filter(isAudioEligible);

/**
 * A class track that was muted had no audio scheduled. Once its buffers finish loading,
 * rebuild playback if the beat is still playing so the kid hears it without pressing
 * Stop and Play again.
 */
export async function rescheduleWhenAudioReady(ready, { isPlaying, reschedule }) {
  await ready;
  if (isPlaying()) reschedule();
}
